// Nhóm mở sẵn và kỳ lọc của danh sách Phiếu kế toán theo URL (kit không đọc nhóm lọc từ URL).
//  ?group=Pending|Posted|Error; liên kết cũ của Chờ ghi sổ còn ?tab=vouchers|templates|groupings|rejected|errors.
//  ?month=YYYYMM (khoá sổ mở phiếu chưa ghi của kỳ); sai định dạng thì bỏ.
const TAB_GROUPS = { vouchers: 'Pending', templates: 'Pending', groupings: 'Pending', rejected: 'Error', errors: 'Error' };
const GROUPS = ['Pending', 'Posted', 'Error'];

export function groupFromTab(tab) {
    return TAB_GROUPS[String(tab || '')] || 'Pending';
}

export function parseVoucherQuery(search) {
    const params = new URLSearchParams(search || '');
    const group = params.get('group');
    const tab = params.get('tab');
    const month = params.get('month');
    const validMonth = /^\d{6}$/.test(String(month || '')) && Number(String(month).slice(4)) >= 1 && Number(String(month).slice(4)) <= 12;
    return {
        group: GROUPS.includes(group) ? group : tab ? groupFromTab(tab) : 'Pending',
        explicit: GROUPS.includes(group) || Boolean(tab),
        month: validMonth ? Number(month) : null
    };
}
